<template>
  <table class="table-condensed">
    <thead>
    <tr>
      <th v-if="!singleDatePickerMode && sideArrowsOn && leftDirection" colspan="1" class="prev available" :class="!singleDatePickerMode ? null : 'singlePrev'" @click="prevMonthClick" tabindex="0" ref="prevMonthBtn"><span /></th>
      <!--<th v-if="showDropdowns" :colspan="showWeekNumbers ? 6 : 5" class="month">-->
      <th v-if="showDropdowns" :colspan="!singleDatePickerMode ? 5 : 6" class="month">
        <div class="row customSelect no-gutters" :class="!singleDatePickerMode ? null : 'justify-content-end'">
          <!-- @Ditravo custom add selectpicker (month)-->
          <!-- month -->
          <select v-model="month" class="monthselect col-auto selectpicker" data-width="98px" data-size="6" @change="changeMonth($event)">
            <option  v-for="(m, idx) in months" :key="idx" :value="m.value + 1" :disabled="!m.enabled" >{{ m.label }}</option>
          </select>

          <!-- year -->
          <!-- @Ditravo custom add selectpicker (year)-->
          <select @change="changeYear($event)" v-model="year" class="yearselect col-auto selectpicker" data-width="98px" data-size="6" @blur="checkYear" ref="yearSelect">
            <option v-for="(y, idx) in yearList" :key="idx" :value="y">{{ y }}</option>
          </select>

          <!-- <input ref="yearSelect" type="number" v-model="year" @blur="checkYear" class="yearselect" /> -->
        </div>
      </th>
      <!--<th v-else :colspan="[sideArrowsOn ? showWeekNumbers ? 6 : 5 : 12]" class="month">{{ monthName }} {{ year }}</th>-->
      <th v-else :colspan="[sideArrowsOn ? 6 : 12]" class="month">{{ monthName }} {{ year }}</th>
      <th v-if="singleDatePickerMode && sideArrowsOn && leftDirection" colspan="1" class="prev available" :class="!singleDatePickerMode ? null : 'singlePrev'" @click="prevMonthClick" tabindex="0" ref="prevMonthBtn"><span /></th>
      <th v-if="sideArrowsOn && rightDirection" colspan="1" class="next available" :class="!singleDatePickerMode ? null : 'singleNext'" @click="nextMonthClick" tabindex="0" ref="nextMonthBtn"><span /></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <th v-if="showWeekNumbers" class="week">{{ locale.weekLabel }}</th>
      <th v-for="(weekDay, idx) in locale.daysOfWeek" :key="idx">{{ weekDay }}</th>
    </tr>
    <tr v-for="(dateRow, index) in calendar" :key="index">
      <td v-if="showWeekNumbers && (index % 7 || index === 0)" class="week">
        {{ $dateUtil.weekNumber(dateRow[0]) }}
      </td>
      <td
          v-for="(date, idx) in dateRow"
          :class="dayClass(date)"
          @click="$emit('date-click', date)"
          @mouseover="$emit('hover-date', date)"
          :key="idx"
          :data-date="date.toISOString().substring(0, 10)"
      >
        <slot name="date-slot" :date="date">
          {{ date.getDate() }}
        </slot>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import dateUtilMixin from "./dateUtilMixin";

export default {
  mixins: [dateUtilMixin],
  name: "calendar",
  props: {
    monthDate: Date,
    localeData: Object,
    start: Date,
    end: Date,
    minDate: Date,
    maxDate: Date,
    showDropdowns: {
      type: Boolean,
      default: false,
    },
    showWeekNumbers: {
      type: Boolean,
      default: false,
    },
    dateFormat: {
      type: Function,
      default: null,
    },
    sideArrowsOn:{
      type:Boolean,
      default:true
    },
    rightDirection:{
      type:Boolean,
      default:false
    },
    leftDirection:{
      type:Boolean,
      default:false
    },
    singleDatePickerMode:{
      type:Boolean,
      default:false
    },
  },
  data() {
    let currentMonthDate = this.monthDate || this.start || new Date();
    return {
      currentMonthDate,
      year_text: currentMonthDate.getFullYear(),
    };
  },
  mounted() {
    this.$emit("prevMonth", this.$refs.prevMonthBtn);
    this.$emit("nextMonth", this.$refs.nextMonthBtn);
  },
  methods: {
    changeMonth(event){
      /**
       * DITRAVO Custom
       */
      let newDate = new Date(this.currentMonthDate.setMonth(Number(event.target.value -1)));
      this.changeMonthDate(newDate, false);
    },
    changeYear(event){
      /**
       * DITRAVO Custom
       */
      if(event){
        let newDate = new Date(this.currentMonthDate.setYear(Number(event.target.value)));
        this.changeMonthDate(newDate, false);
        this.$nextTick(()=>{
          $('.monthselect').selectpicker('refresh');
        })
      }
    },
    prevMonthClick() {
      this.changeMonthDate(this.$dateUtil.prevMonth(this.currentMonthDate));
      if(this.singleDatePickerMode){
        let datePickerTableElement = document.querySelectorAll(".singleDatePickerMode .daterangepicker .calendars .calendars-container .drp-calendar table tbody tr");
        for (let i = 1; i < datePickerTableElement.length; ++i) {
          datePickerTableElement[i].classList.remove("slide-in-left");
          datePickerTableElement[i].classList.remove("slide-in-right");
          datePickerTableElement[i].classList.add("slide-in-left");
          setTimeout(()=>{
            datePickerTableElement[i].classList.remove("slide-in-left");
          }, 500);
        }
        let datePickerMonthDropdownElement = document.querySelector(".singleDatePickerMode .daterangepicker .calendars .calendars-container .drp-calendar .monthselect");
        let datePickerYearDropdownElement = document.querySelector(".singleDatePickerMode .daterangepicker .calendars .calendars-container .drp-calendar .yearselect");
        datePickerMonthDropdownElement.classList.remove("fade-in");
        datePickerYearDropdownElement.classList.remove("fade-in");
        datePickerMonthDropdownElement.classList.add("fade-in");
        datePickerYearDropdownElement.classList.add("fade-in");
        setTimeout(()=>{
          datePickerMonthDropdownElement.classList.remove("fade-in");
          datePickerYearDropdownElement.classList.remove("fade-in");
          }, 500);


        //DitravoCustom
        // this.$emit("prevMonth", this.$refs.prevMonthBtn);

      }
      this.$nextTick(()=>{
        $('.monthselect').selectpicker('refresh');
        $('.yearselect').selectpicker('refresh');
        if(this.month === 1 || this.month === 12){
          this.$nextTick(()=>{
            $('.yearselect').selectpicker('refresh');
          })
        }
      })

    },
    nextMonthClick() {
      //DitravoCustom
      // this.$emit("nextMonth", this.$refs.nextMonthBtn);
      if(new Date(this.currentMonthDate.getFullYear(), this.currentMonthDate.getMonth()).toDateString() === new Date(this.maxDate.getFullYear(), this.maxDate.getMonth()).toDateString()) return;
      this.changeMonthDate(this.$dateUtil.nextMonth(this.currentMonthDate));
      if(this.singleDatePickerMode){
        let datePickerTableElement = document.querySelectorAll(".singleDatePickerMode .daterangepicker .calendars .calendars-container .drp-calendar table tbody tr");
        for(let i = 1; i < datePickerTableElement.length; i++){
          datePickerTableElement[i].classList.remove("slide-in-left");
          datePickerTableElement[i].classList.remove("slide-in-right");
          datePickerTableElement[i].classList.add("slide-in-right");
          setTimeout(()=>{
            datePickerTableElement[i].classList.remove("slide-in-right");
          }, 500);
          let datePickerMonthDropdownElement = document.querySelector(".singleDatePickerMode .daterangepicker .calendars .calendars-container .drp-calendar .monthselect");
          let datePickerYearDropdownElement = document.querySelector(".singleDatePickerMode .daterangepicker .calendars .calendars-container .drp-calendar .yearselect");
          datePickerMonthDropdownElement.classList.remove("fade-in");
          datePickerYearDropdownElement.classList.remove("fade-in");
          datePickerMonthDropdownElement.classList.add("fade-in");
          datePickerYearDropdownElement.classList.add("fade-in");
          setTimeout(()=>{
            datePickerMonthDropdownElement.classList.remove("fade-in");
            datePickerYearDropdownElement.classList.remove("fade-in");
          }, 500);
        }
      }
      this.$nextTick(()=>{
        $('.monthselect').selectpicker('refresh');
        $('.yearselect').selectpicker('refresh');
        if(this.month === 1 || this.month === 12){
          this.$nextTick(()=>{
            $('.yearselect').selectpicker('refresh');
          })
        }
      })
    },
    changeMonthDate(date, emit = true) {
      let year_month = this.$dateUtil.yearMonth(this.currentMonthDate);
      let newMaxDate = new Date(this.maxDate);

      newMaxDate.setMonth(newMaxDate.getMonth());
      // console.log(newMaxDate);
      this.currentMonthDate = this.$dateUtil.validateDateRange(date, this.minDate, newMaxDate);
      /**
       * DITRAVO Custom
       */
      // console.info(date, this.currentMonthDate)
      if (emit && year_month !== this.$dateUtil.yearMonth(this.currentMonthDate)) {
        this.$emit("change-month", {
          month: this.currentMonthDate.getMonth() + 1,
          year: this.currentMonthDate.getFullYear(),
        });
      }
      this.checkYear();
    },
    dayClass(date) {
      let dt = new Date(date);
      dt.setHours(0, 0, 0, 0);
      let start = new Date(this.start);
      start.setHours(0, 0, 0, 0);
      let end = new Date(this.end);
      end.setHours(0, 0, 0, 0);

      let dt_min_compare = new Date(dt);
      dt_min_compare.setHours(23, 59, 59, 999);

      // console.log(date);
      // console.log(date.getMonth() + 1 !== this.month);
      // console.log("---")
      let classes = {
        off: date.getMonth() + 1 !== this.month,
        weekend: date.getDay() === 6 || date.getDay() === 0,
        today: dt.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0),
        active: dt.setHours(0, 0, 0, 0) == new Date(this.start).setHours(0, 0, 0, 0) || dt.setHours(0, 0, 0, 0) == new Date(this.end).setHours(0, 0, 0, 0),
        "in-range": dt >= start && dt <= end,
        "start-date": dt.getTime() === start.getTime(),
        "end-date": dt.getTime() === end.getTime(),
        disabled: (this.minDate && dt_min_compare.getTime() < this.minDate.getTime()) || (this.maxDate && dt.getTime() > this.maxDate.getTime()),
      };
      return this.dateFormat ? this.dateFormat(classes, date) : classes;
    },
    checkYear() {
      if (this.$refs.yearSelect !== document.activeElement) {
        this.$nextTick(() => {
          this.year_text = this.monthDate.getFullYear();
        });
      }
    },
  },
  computed: {
    monthName() {
      return this.locale.monthNames[this.currentMonthDate.getMonth()];
    },
    yearList(){
      /**
       * DITRAVO Custom
       */

      function range(start, end) {
        return Array(end - start + 1).fill().map((_, idx) => start + idx)
      }
      if(this.minDate && this.maxDate){
        let result = range(this.minDate.getFullYear(), this.maxDate.getFullYear());
        return result;
      }else if(this.maxDate){
        let result = range(1900, this.maxDate.getFullYear());
        return result;
      }else{
        let result = range(1900, 2100);
        return result;
      }
    },
    year: {
      get() {
        //return this.currentMonthDate.getFullYear()
        return this.year_text;
      },
      set(value) {
        this.year_text = value;
        let newDate = this.$dateUtil.validateDateRange(new Date(value, this.month, 1), this.minDate, this.maxDate);
        if (this.$dateUtil.isValidDate(newDate)) {
          this.$emit("change-month", {
            month: newDate.getMonth(),
            year: newDate.getFullYear(),
          });
        }
      },
    },
    month: {
      get() {
        return this.currentMonthDate.getMonth() + 1;
      },
      set(value) {
        let newMaxDate = new Date(this.maxDate);

        newMaxDate.setMonth(newMaxDate.getMonth()+1);
        let newDate = this.$dateUtil.validateDateRange(new Date(this.year, value - 1, 1), this.minDate, newMaxDate);

        this.$emit("change-month", {
          month: newDate.getMonth() + 1,
          year: newDate.getFullYear(),
        });
      },
    },
    calendar() {
      let month = this.month;
      let year = this.currentMonthDate.getFullYear();
      let firstDay = new Date(year, month - 1, 1);
      let lastMonth = this.$dateUtil.prevMonth(firstDay).getMonth() + 1;
      let lastYear = this.$dateUtil.prevMonth(firstDay).getFullYear();
      let daysInLastMonth = new Date(lastYear, month - 1, 0).getDate();

      let dayOfWeek = firstDay.getDay();

      let calendar = [];

      for (let i = 0; i < 6; i++) {
        calendar[i] = [];
      }

      let startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
      if (startDay > daysInLastMonth) startDay -= 7;

      if (dayOfWeek === this.locale.firstDay) startDay = daysInLastMonth - 6;

      let curDate = new Date(lastYear, lastMonth - 1, startDay, 12, 0, 0);
      for (let i = 0, col = 0, row = 0; i < 6 * 7; i++, col++, curDate.setDate(curDate.getDate() + 1)) {
        if (i > 0 && col % 7 === 0) {
          col = 0;
          row++;
        }
        calendar[row][col] = new Date(curDate.getTime());
      }

      let targetMonth = calendar[1][0];
      let firstCalendarRow = calendar[0];

      let sameMonthExistsInFirstRow = false;
      for (let i = 0; i < firstCalendarRow.length; i++) {
        sameMonthExistsInFirstRow = new Date(firstCalendarRow[i]).getMonth() == new Date(targetMonth).getMonth();
      }

      let newCalendar = [];
      if(sameMonthExistsInFirstRow) {
        for (let i = 0; i < 6; i++) {
          newCalendar[i] = calendar[i];
        }
      }else{
        for (let i = 0; i < 5; i++) {
          newCalendar[i] = calendar[i+1];
        }
      }

      return newCalendar;
    },
    months() {
      return this.locale.monthNames.map((m, idx) => ({
        label: m,
        value: idx,
        enabled: (!this.maxDate || this.maxDate >= new Date(this.year, idx, 1)) && (!this.minDate || this.minDate <= new Date(this.year, idx + 1, 0)),
      }));
    },
    locale() {
      return this.$dateUtil.localeData(this.localeData);
    },
  },
  watch: {
    monthDate(value) {
      if(!this.singleDatePickerMode){
        if (this.currentMonthDate.getTime() !== value.getTime()) {
          this.changeMonthDate(value, false);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
th,
td {
  padding: 2px;
  background-color: white;
}

td.today {
  font-weight: bold;
}

td.disabled {
  pointer-events: none;
  background-color: #eee;
  border-radius: 0;
  opacity: 0.6;
}

@function str-replace($string, $search, $replace: "") {
  $index: str-index($string, $search);

  @if $index {
    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);
  }

  @return $string;
}

$carousel-control-color: #ccc !default;
$viewbox: "-2 -2 10 10";
$carousel-control-prev-icon-bg: str-replace(
        url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='#{$viewbox}'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E"),
        "#",
        "%23"
) !default;
$carousel-control-next-icon-bg: str-replace(
        url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='#{$viewbox}'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E"),
        "#",
        "%23"
) !default;

.fa {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: transparent no-repeat center center;
  background-size: 100% 100%;
  fill: $carousel-control-color;
}

.prev,
.next {
  //**
  //     * DITRAVO Custom
  //     *
  pointer-events: visible !important;
  opacity: 1 !important;
  &:hover {
    background-color: transparent !important;
  }

  .fa:hover {
    opacity: 0.6;
  }
}

.chevron-left {
  width: 16px;
  height: 16px;
  display: block;
  background-image: $carousel-control-prev-icon-bg;
}

.chevron-right {
  width: 16px;
  height: 16px;
  display: block;
  background-image: $carousel-control-next-icon-bg;
}

.yearselect {
  padding-right: 1px;
  border: none;
  appearance: menulist;
}

.monthselect {
  border: none;
}


::v-deep{
  .singlePrev{
    left: 0 !important;
  }
  .singleNext{
    right: inherit !important;
  }
}
</style>
